var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserCat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_839_215)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 15,
    fill: "#D8CAFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_839_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4394 37.49C29.3038 37.49 28.1711 37.9994 27.0371 37.9592C25.771 37.9144 24.8272 36.9185 24.8259 35.6684C24.8252 34.9546 24.7641 34.2372 24.8993 33.5268C25.2749 31.5526 27.0196 30.0829 29.0538 30.0472C29.9879 30.0308 30.9223 30.0302 31.8568 30.0453C32.9827 30.063 34.0573 30.5125 34.8526 31.2986C35.648 32.0846 36.1015 33.1453 36.117 34.2556C36.126 34.8566 36.1737 35.4614 36.0825 36.0596C35.9292 37.0646 35.0486 37.8892 34.0218 37.955C33.0176 38.0194 32.006 37.4904 31 37.5002C30.8131 37.5021 30.6263 37.5005 30.4394 37.5005L30.4394 37.49Z",
    fill: "#2A2A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7506 26.0474C33.7266 28.0325 32.2728 29.3226 30.5095 29.3462C28.6637 29.371 27.1502 27.8686 27.1553 26.0616C27.1602 24.3253 28.7211 22.832 30.5385 22.8279C32.0878 22.8244 33.7834 24.1346 33.7506 26.0474Z",
    fill: "#2A2A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3013 29.2586C33.4407 29.1285 33.5666 29.0136 33.6895 28.8957C33.7659 28.8217 33.8575 28.7645 33.958 28.7279C34.0585 28.6913 34.1658 28.6761 34.2727 28.6834C35.0775 28.6986 35.8828 28.6866 36.6878 28.693C38.527 28.7076 40.0744 29.8142 40.6295 31.5082C40.7562 31.8779 40.8208 32.2655 40.8205 32.6558C40.8128 33.2289 40.8724 33.8046 40.7834 34.375C40.6381 35.3058 39.8355 36.0626 38.8863 36.172C38.3274 36.2364 37.7659 36.1869 37.2059 36.2038C37.0965 36.2071 37.0898 36.1728 37.0932 36.0688C37.123 35.1703 37.2094 34.2648 37.0273 33.3767C36.6226 31.4024 35.4427 30.0621 33.535 29.3439C33.4683 29.3188 33.4012 29.295 33.3013 29.2586Z",
    fill: "#2A2A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5986 29.2768C26.7588 29.5318 25.9963 29.9885 25.3795 30.6058C24.3659 31.629 23.8352 32.8561 23.8252 34.2896C23.8209 34.8981 23.7852 35.508 23.8553 36.1154C23.8635 36.1862 23.8351 36.2044 23.7744 36.2022C23.1156 36.1774 22.4497 36.277 21.7987 36.1229C20.8481 35.8979 20.1371 35.0386 20.1258 34.0772C20.1176 33.3847 20.0528 32.6868 20.1911 31.9997C20.5782 30.0756 22.1618 28.7487 24.1472 28.6983C25.0018 28.6765 25.8574 28.6988 26.7124 28.692C26.9731 28.6899 27.1848 28.7494 27.3332 28.9799C27.4015 29.0859 27.5026 29.1713 27.5986 29.2768Z",
    fill: "#2A2A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2966 25.0714C22.3173 23.3336 23.7788 21.9907 25.597 22.0383C26.3078 22.0501 26.9892 22.3199 27.511 22.7961C27.6169 22.8901 27.61 22.9356 27.5088 23.0315C26.1798 24.2913 25.8056 26.1468 26.5472 27.81C26.6145 27.9611 26.5663 27.9979 26.4354 28.0425C24.4126 28.7324 22.2713 27.1966 22.2966 25.0714Z",
    fill: "#2A2A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3184 22.9008C34.2522 22.0634 35.3267 21.8223 36.5286 22.1953C38.1223 22.69 38.7514 24.1985 38.5933 25.4416C38.3819 27.1029 37.2514 28.1195 35.5535 28.2004C35.1792 28.2124 34.8063 28.1518 34.4557 28.0221C34.367 27.9911 34.3306 27.9651 34.3753 27.8579C35.1554 25.9857 34.7835 24.3475 33.3353 22.9313C33.3287 22.9217 33.323 22.9115 33.3184 22.9008Z",
    fill: "#2A2A2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_839_215",
    x: 0,
    y: 0,
    width: 60,
    height: 60,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_839_215"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_839_215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 16,
    fill: "white",
    transform: "translate(20 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCat);
export default __webpack_public_path__ + "static/media/user_cat.5486665a1e444e9b2850fa6997c5f6a8.svg";
export { ForwardRef as ReactComponent };